import { EditIcon } from '@atoms/Icons/EditIcon';
import { DATE_FORMAT } from '@constants';
import { Box, Chip, IconButton, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';

import { MonitoringItem } from '@services';
import dayjs from 'dayjs';
import {
  MONITORING_ASSET_MAPPER,
  MonitoringAssetStatusEnum,
} from 'src/features/Enterprise/Monitoring/utils';

const getStatus = (monitoringStatus: MonitoringAssetStatusEnum) => {
  let color: 'default' | 'warning' | 'success' = 'default';

  switch (monitoringStatus) {
    case MonitoringAssetStatusEnum.Active:
      color = 'success';
      break;
    default:
      color = 'warning';
      break;
  }

  return { status: MONITORING_ASSET_MAPPER[monitoringStatus], color };
};

interface Props {
  onClickEdit: (row: MonitoringItem) => void;
  onClickDelete: (row: MonitoringItem) => void;
}

export function getColumns({ onClickEdit }: Props): GridColDef<MonitoringItem>[] {
  return [
    {
      field: 'title',
      headerName: 'Asset Title',
      flex: 3,
      minWidth: 220,
      renderCell: ({ row }) => (
        <Typography color="#3369E8" noWrap>
          {row.title}
        </Typography>
      ),
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }) => {
        const data = getStatus(row.status);
        return <Chip color={data.color} label={data.status} />;
      },
    },
    {
      field: 'createdAt',
      headerName: 'Date of Addition',
      flex: 1.5,
      minWidth: 180,
      renderCell: ({ value }) => dayjs(value).format(DATE_FORMAT),
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 100,
      renderCell: ({ row }) => (
        <Box>
          <IconButton onClick={() => onClickEdit(row)}>
            <EditIcon />
          </IconButton>
          {/* <IconButton onClick={() => onClickDelete(row)}>
            <DeleteIcon />
          </IconButton> */}
        </Box>
      ),
      sortable: false,
    },
  ];
}
